import { combineReducers } from 'redux';
import { LoginReducer, LockReducer, UserLockReducer } from './Auth';
import { AddContractReducer } from './Contracts';
import { AddExceptionReducer } from './Exception';
import { AddMultipleConfigurationReducer } from './Configuration';
import {
  CalculationSimulationReducer,
  OperationalReportsReducer,
} from './Simulations';
import { DataSetupReducer, ManipulateDataReducer, CustomDataReducer } from './DataSetup';
import { DashboardReducer } from './Initial';
import { persistReducer } from 'redux-persist';
import { ProfileReducer } from './Profile';
import storage from 'redux-persist/lib/storage';
import { AddCustomerReducer, RebatesReducer } from './Customers';
import { FormulaLabReducer } from './FormulaLab';
import {
  AddKeyFigureReducer,
  AttributeMapReducer,
  BasisMapReducer,
  AnalyticsDesignerReducer,
  HelpDeskReducer,
} from './CalculationDesigner';
import { AttributesReducer } from './Attributes';
import { ChangeManagementReducer } from './DesignerStudio'
import { ContractConfigurationReducer } from './DesignerStudio'
import { ContractTypeConfigurationReducer } from './DesignerStudio';
import { HolidayCalendarReducer } from './HolidayCalendar';
import { FinancialCloseReducer } from './FinancialClose';
import { CalculationAnalysisReducer } from './Calculation Analysis';
import { TerritoryReducer } from './Territory';
import { ExternalFormulaResults } from './ExternalFormulaResults';
import { UoMReducer } from './UoM';
import { PromotionReducer } from './Promotion';
import { AuditLabReducer } from './AuditLab';
import { PricingReducer } from './Pricing';
import { ForecastingReducer } from './Forecasting';
import { ProfitOptimizationReducer } from './ProfitOptimizationConfig';
import { QueryFieldReducer } from './QueryField';
import AnamolyReducer from './AnamolyConfig/AnamolyConfig.Reducer';
import CollaborationDesignerReducer from './CollaborationDesigner/CollaborationDesigner.Reducer';
import { DocumentManagementReducer } from './DocumentManagement';
import NewFormulaBuilderReducer from './DesignerStudio/NewFormulaBuilder/NewFormulaBuilder.Reducer';
import masterData from './MasterData/MasterDataReducer';
import dashboardConfigReducer from './DashboardConfig/DashboardConfigReducer';
import SalesCommissionReducer from './SalesCommission/SalesCommission.Reducer';
import { CalendarManagerReducer } from './CalendarManager';
import { CalendarReducer } from './Calendar';
import AlertManagementReducer from './AlertManagement';
import ContractCompilanceReducer from './ContractCompilance/ContractCompilance.Reducer';
import PriceComplianceSimulationReducer from './ContractCompilance/PriceComplianceSimulation.Reducer';
import RoyaltyReducer from './Royalty/Royalty.Reducer';
import GeneralReducer from './General/General.Reducer';
import { DataAnalyticsReducer } from './DataAnalytics';
import SupplierRebateReducer from './SupplierRebate/SupplierRebate.Reducer';
import SalesRebateReducer from './SalesRebate/SalesRebate.Reducer';
import DistributorChargebackReducer from './DistributorChargeback/DistributorChargeback.Reducer';
import ManufacturerChargebackReducer from './ManufacturerChargeback/ManufacturerChargeback.Reducer';
import PriceManagementContractReducer from './PriceManagementContract/PriceManagementContract.Reducer';
import { CPQReducer } from './CPQ';
import MassPostingsReducer from './MassPostings/MassPostings.Reducer';
const persistConfig = {
  key: 'auth',
  storage: storage,
  migrate: async (state) => {
    if (state) {
      storage.removeItem('persist:auth'); // Clears old auth state
    }
    return Promise.resolve(state);
  },
  whitelist: [
    'loginData',  // Keep only authentication state
    'profileData',
    'customerData',
    'holidayCalendarData',
    'financialCloseData',
    'dashboardConfig',
  ],
  blacklist: [
    'dashboards',
    'addMultipleConfigurationData', // Prevent storing large datasets
    'simulationData',
    'operationalReportsData',
    'newFormulaBuilder',
    'dataSetupData',
    'AnalyticsDesignerData',
    'QueryFieldData',
    'externalFormulaResultsData',
    'forecastData',
    'profitOptimizationData',
    'pricingData',
    'auditLabData',
    'FormulaLabData',
    'HelpDeskData',
    'DocumentManagement',
    'LockData',
    'dataManipulate',
    'dashboardConfig',
    'dataAnalyticsData',
    'CPQData',
    'massPostingsData',
  ]
};

const RootReducer = combineReducers({
  loginData: LoginReducer,
  addContractData: AddContractReducer,
  addExceptionData: AddExceptionReducer,
  addMultipleConfigurationData: AddMultipleConfigurationReducer,
  initialData: DashboardReducer,
  simulationData: CalculationSimulationReducer,
  dataSetupData: DataSetupReducer,
  dataManipulate: ManipulateDataReducer,
  customData: CustomDataReducer,
  newFormulaBuilder: NewFormulaBuilderReducer,
  operationalReportsData: OperationalReportsReducer,
  profileData: ProfileReducer,
  customerData: AddCustomerReducer,
  rebatesData: RebatesReducer,
  FormulaLabData: FormulaLabReducer,
  AddKeyFigureData: AddKeyFigureReducer,
  AttributeMapData: AttributeMapReducer,
  attributeListData: AttributesReducer,
  holidayCalendarData: HolidayCalendarReducer,
  financialCloseData: FinancialCloseReducer,
  calculationAnalysisData: CalculationAnalysisReducer,
  BasisMapData: BasisMapReducer,
  territoryData: TerritoryReducer,
  externalFormulaResultsData: ExternalFormulaResults,
  uomData: UoMReducer,
  promotionData: PromotionReducer,
  auditLabData: AuditLabReducer,
  pricingData: PricingReducer,
  forecastData: ForecastingReducer,
  profitOptimizationData: ProfitOptimizationReducer,
  AnalyticsDesignerData: AnalyticsDesignerReducer,
  HelpDeskData: HelpDeskReducer,
  QueryFieldData: QueryFieldReducer,
  AnamolyData: AnamolyReducer,
  CollaborationDesignerData: CollaborationDesignerReducer,
  DocumentManagement: DocumentManagementReducer,
  LockData: LockReducer,
  userLockData: UserLockReducer,
  masterData: masterData,
  dashboardConfig: dashboardConfigReducer,
  changeManagementData: ChangeManagementReducer,
  salesCommissionData: SalesCommissionReducer,
  calendarManagerData: CalendarManagerReducer,
  contractConfigurationData: ContractConfigurationReducer,
  calendarData: CalendarReducer,
  contractTypeConfigurationData: ContractTypeConfigurationReducer,
  alertManagementData: AlertManagementReducer,
  compilanceData: ContractCompilanceReducer,
  priceComplianceSimulationData: PriceComplianceSimulationReducer,
  royaltyData: RoyaltyReducer,
  generalData: GeneralReducer,
  dataAnalyticsData: DataAnalyticsReducer,
  supplierRebateData: SupplierRebateReducer,
  salesRebateData: SalesRebateReducer,
  distributorChargebackData: DistributorChargebackReducer,
  manufacturerChargebackData: ManufacturerChargebackReducer,
  priceManagementContractData: PriceManagementContractReducer,
  CPQData: CPQReducer,
  massPostingsData: MassPostingsReducer,
});

export default persistReducer(persistConfig, RootReducer);
